export default "__VITE_ASSET__2642662e__"